import { useCallback, useEffect, useState } from 'react'
import { callTangerineApi } from './api'

export const useTangerineApi = ({
  path,
  params = {},
  endpointSuffix = '',
  axiosOptions = {},
  skip = false,
  method = 'GET',
}) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [errors, setErrors] = useState([])
  const [refetchCount, setRefetchCount] = useState(0)

  const refetch = useCallback(() => setRefetchCount((c) => c + 1), [])

  const fullPath = path + endpointSuffix
  const signature = JSON.stringify({ path: fullPath, params })

  useEffect(
    () => {
      if (skip) {
        setLoading(false)
        return {}
      }
      async function fetch() {
        try {
          if (method !== 'PATCH') setLoading(true)
          const data = await callTangerineApi({
            path: fullPath,
            params,
            axiosOptions,
            method,
          })
          setData(data)
        } catch (error) {
          setErrors(error)
        } finally {
          setLoading(false)
        }
      }
      fetch()
    },
    // eslint-disable-next-line
    [fullPath, signature, refetchCount],
  )

  return {
    data,
    loading,
    errors,
    refetch,
  }
}
